import React from 'react';
import { Modal } from 'react-bootstrap';

class SearchFilterModal extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <div>
        <Modal show={this.props.showModal} onHide={this.props.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.props.children}
          </Modal.Body>
          <Modal.Footer>
            <button onClick={this.props.closeModal}>Close</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default SearchFilterModal;
